import Common from '../../Common';

const Contact = class extends Common {
	browse = (userId?: id, search = {}): CustomResponseWithPagination<{
		search: null | string
		order_by: string
		order_dir: string
		contacts: Contact[]
	}> => {
		if(!userId) {
			return this.get(`/user/contacts`, search)
		}

		return this.get(`/user/${userId}/contacts`, search)
	}

	read = (userId: id, contactId: id) =>
		this.get(`/user/${userId}/contacts/${contactId}`)

	delete = (userId: id, contactId: id) =>
		this.doDelete(`/user/${userId}/contacts/${contactId}`)
}

export default Contact
